import { styled } from '../../../../../modules';

export const PanelWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    min-height: 0;
    overflow: hidden;
`;

export const ViewerArea = styled.div`
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const DocumentFrame = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    display: block;
`;
